// A receipt's address and how its page finds it
// (02-DESIGN/18-billing/02-the-billing-page.md § the tab — Receipts; verb
// table row 119): `settings/billing/receipts/<id>`, read on
// billing.charges.list a page at a time until the id, since the family has
// no verb that reads one charge.

import { tenantPath } from "../../address/address.ts";
import type { Charge, ChargesListReply, ChargesListRequest } from "../../wire/billing.ts";

/** receiptPath is a receipt's page: `/<slug>/settings/billing/receipts/<id>`. */
export function receiptPath(slug: string, id: string): string {
  return tenantPath(slug, "settings", "billing", "receipts", id);
}

/** billingPath is the Billing tab's address: `/<slug>/settings/billing`. */
export function billingPath(slug: string): string {
  return tenantPath(slug, "settings", "billing");
}

/** MAX_PAGES bounds the walk: a receipt further back than this many pages is not found. */
export const MAX_PAGES = 50;

/** findCharge walks the charges newest first, a page at a time, until the id; nothing when it is not the root's. */
export async function findCharge(
  list: (req: ChargesListRequest) => Promise<ChargesListReply>,
  id: string,
): Promise<Charge | undefined> {
  let before: string | undefined;
  for (let i = 0; i < MAX_PAGES; i++) {
    const page = await list(before === undefined ? { limit: 100 } : { before, limit: 100 });
    const hit = page.charges.find((c) => c.id === id);
    if (hit !== undefined) {
      return hit;
    }
    if (page.next === undefined || page.next === "") {
      return undefined;
    }
    before = page.next;
  }
  return undefined;
}
